module.exports = __webpack_public_path__ + "img/4.25a4ba20.png";